import {DataColumn} from '@spa/reporting';

import {BaseControl} from 'appShared/classes';

import {ReportTableDataInterface} from '..';

export class ReportTableData<ValueType = any> extends DataColumn<ValueType> {
    public control: BaseControl;
    public shownControl: boolean;
    public title: string;
    public valueClass: string;
    public actionIconClass: string;
    public actionTitle: string;

    constructor(data: ReportTableDataInterface<ValueType>) {
        super(data);

        this.control = !data.control ? null : data.control;
        this.shownControl = data.shownControl;
        this.title = data.title;
        this.valueClass = data.valueClass;
        this.actionIconClass = data.actionIconClass;
        this.actionTitle = data.actionTitle;
    }
}
